import "../assets/index-418d4e87.css";
import { n as t } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const a = {
  name: "NcActionCaption",
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * The caption's text
     */
    name: {
      type: String,
      required: !0
    }
  }
};
var i = function() {
  var n = this, e = n._self._c;
  return e("li", { staticClass: "app-navigation-caption", attrs: { role: n.isInSemanticMenu && "presentation" } }, [n._v(" " + n._s(n.name) + " ")]);
}, c = [], o = /* @__PURE__ */ t(
  a,
  i,
  c,
  !1,
  null,
  "7c8f7463",
  null,
  null
);
const p = o.exports;
export {
  p as default
};
